export const LOAD_ACCOUNT_REQUEST = 'onboarding/completed/LOAD_ACCOUNT_REQUEST'
export const LOAD_ACCOUNT_SUCCESS = 'onboarding/completed/LOAD_ACCOUNT_SUCCESS'
export const LOAD_ACCOUNT_FAILURE = 'onboarding/completed/LOAD_ACCOUNT_FAILURE'
